<template>
	<BaseCard :title="$t('damage_assessor').toString()">
		<div class="flex flex-col mb-10" v-if="!isLoading">
			<div>
				<div class="flex flex-row justify-between">
					<div class="w-80 mb-6">
						<BaseInput :filter-only="true" :label="$t('search')" v-model="sword" />
					</div>
					<div class="mt-8">
						<AddButton
							style="text-align: start; min-width: 240px; max-width: 240px"
							@click="$router.push({ name: 'repair_shop.service_provider.apply_damage_assessor' })"
							>{{ $t('apply_new_damage_assessor') }}</AddButton
						>
					</div>
				</div>

				<div class="m-4" v-if="this.getFilteredDamageAssessors && this.getFilteredDamageAssessors.length <= 0 && this.sword == null">
					<b>{{ $t('no_available_assessors') }}</b>
				</div>
				<div class="m-4" v-else-if="this.getFilteredDamageAssessors && this.getFilteredDamageAssessors.length <= 0 && this.sword != null">
					<b>{{ $t('no_entries_found') }}</b>
				</div>
				<div
					class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded"
					v-if="this.getFilteredDamageAssessors && this.getFilteredDamageAssessors.length > 0"
				>
					<table class="min-w-full">
						<thead class="w-full" style="height: fit-content;">
							<tr class="w-full">
								<HeaderColumn style="width: fit-content">{{ $t('service_provider') }}</HeaderColumn>
								<HeaderColumn>{{ $t('address') }}</HeaderColumn>
								<HeaderColumn>{{ $t('phone') }}</HeaderColumn>
								<HeaderColumn>{{ $t('e_mail') }}</HeaderColumn>
							</tr>
						</thead>
						<tbody class="bg-white">
							<tr v-for="(damageAssessor, index) in getFilteredDamageAssessors" :key="damageAssessor.id" class="tr odd:bg-gray-200">
								<td class="px-4 py-4 w-3/12" :class="getFilteredDamageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									<div>{{ damageAssessor.ownerFirstname }} {{ damageAssessor.ownerLastname }}</div>
									<div v-if="damageAssessor.companyable.self_employed !== 1">Firma {{ damageAssessor.name }}</div>
								</td>
								<td class="py-4 w-3/12" :class="getFilteredDamageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ getAddress(damageAssessor) }},
									{{ damageAssessor.city.zipCode }}
									{{ damageAssessor.city.name }}
								</td>
								<td class="py-4 w-1/12" :class="getFilteredDamageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ damageAssessor.phoneNumber }}
								</td>
								<td class="py-4 w-3/12" :class="getFilteredDamageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ damageAssessor.email }}
								</td>
								<td
									class="py-4 pr-4 w-2/12"
									style="text-align: end"
									:class="getFilteredDamageAssessors.length !== index + 1 ? 'border-b border-gray-200' : ''"
								>
									<Toggle :active="!damageAssessor.isDisabled" @click="disableRow(damageAssessor)" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import RepairShopRepository from '@/api/repositories/RepairShopRepository';
import AddButton from '@/components/forms/buttons/AddButton';
import Toggle from '@/components/forms/Toggle';
import HeaderColumn from '@/components/columns/HeaderColumn';
import BaseInput from '@/components/forms/inputs/BaseInput';

export default {
	name: 'ServiceProviderDamageAssessorCard',
	components: { HeaderColumn, BaseInput, Toggle, AddButton, BaseCard },
	data() {
		return {
			damageAssessors: undefined,
			isLoading: true,
			sword: '',
		};
	},
	computed: {
		getFilteredDamageAssessors() {
			return this.damageAssessors.filter(
				el =>
					el.ownerLastname.toLowerCase().includes(this.sword.toLowerCase()) ||
					el.ownerFirstname.toLowerCase().includes(this.sword.toLowerCase()) ||
					el.name.toLowerCase().includes(this.sword.toLowerCase()),
			);
		},
	},
	methods: {
		getAddress(company) {
			if (company.street === undefined || company.street === null) {
				return this.$t('po_box') + ' ' + company.poBox;
			} else {
				if (company.houseNumber != null) {
					return `${company.street} ${company.houseNumber || ''}`;
				} else {
					return company.street;
				}
			}
		},
		getDamageAssessors() {
			const repairshopId = this.$store.getters.getUser.person.company.companyable.id;
			RepairShopRepository.damageAssessors(repairshopId, { trashed: true }).then(response => {
				this.damageAssessors = response.data.data;
				this.isLoading = false;
			});
		},
		disableRow(damageAssessor) {
			const repairshopId = this.$store.getters.getUser.person.company.companyable.id;

			this.$swal({
				title: this.$t('sure').toString(),
				text: damageAssessor.isDisabled ? this.$t('activate_damage_assessor').toString() : this.$t('deactivate_damage_assessor').toString(),
				icon: 'warning',
				cancelButtonText: this.$t('general.no').toString(),
				showCancelButton: true,
				confirmButtonText: this.$t('general.yes').toString(),
			}).then(result => {
				if (result.value) {
					RepairShopRepository.disableDamageAssessor(repairshopId, damageAssessor.id, !damageAssessor.isDisabled).then(() => {
						this.$set(damageAssessor, 'isDisabled', !damageAssessor.isDisabled);
					});
				}
			});
		},
	},
	mounted() {
		this.isLoading = true;
		this.getDamageAssessors();
	},
};
</script>
